const typeChecker = {
  typeOf(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1)
  },
  isDate(obj) {
    return this.typeOf(obj) === 'Date'
  },
}
export default Object.freeze(typeChecker)
